import React from 'react'
import PropTypes from 'prop-types'

import { Column, Columns, Container } from '@resurs/midas-react'

import { getText } from '../../../../internal/TextLabels'
import { Tabs } from '../../../../midasComponents'
import BonusChecks from '../shared/BonusChecks/BonusChecks'
import { renderBonusLabel } from '../shared/BonusChecks/UIHelpers'
import DebitPayment from './DebitPayment'
import PaymentMethodDescription from './PaymentMethodDescription'
import PaymentMethodHeader from './PaymentMethodHeader'

const PspPaymentMethod = ({
  selectedPaymentMethod,
  newPageLoading,
  debitPaymentChecked,
  onDebitPaymentSwitch,
  onChangeAmount,
  debitReference,
  onChangeDebitReference,
  bonusChecks,
  hasBonusSupport,
  isValid,
}) => {
  return (
    <Container>
      <Columns>
        <Column col12>
          <PaymentMethodHeader
            description={selectedPaymentMethod.description}
          />
        </Column>
        <Column col12>
          <Tabs
            fullWidth
            contentStyling={{ minHeight: '175px' }}
            values={[
              {
                value: getText('payApply.paymentMethods.tabs.handle'),
                active: true,
                content: (
                  <div
                    style={{
                      marginTop: '1rem',
                      padding: '1rem 2rem 2rem',
                      border: '1px solid lightgrey',
                    }}
                  >
                    <DebitPayment
                      hideDebitReference // debitReference is overridden by psp transaction id in payment-engine, hide for now
                      disabled={newPageLoading}
                      debitPaymentChecked={debitPaymentChecked}
                      isValid={validation => {
                        if (validation.key === 'debit-amount') {
                          isValid(validation.valid)
                        } else {
                          isValid(false)
                        }
                      }}
                      onDebitPaymentSwitch={checked =>
                        onDebitPaymentSwitch(checked)
                      }
                      onChangeAmount={newAmount => onChangeAmount(newAmount)}
                      debitReference={debitReference}
                      onChangeDebitReference={ref =>
                        onChangeDebitReference(ref)
                      }
                      minPurchaseLimit={selectedPaymentMethod.minPurchaseLimit}
                      maxPurchaseLimit={selectedPaymentMethod.maxPurchaseLimit}
                    />
                  </div>
                ),
              },
              {
                value: getText('payApply.paymentMethods.tabs.info'),
                content: (
                  <div style={{ marginTop: '2rem' }}>
                    <PaymentMethodDescription method={selectedPaymentMethod} />
                  </div>
                ),
              },
              {
                value: renderBonusLabel(bonusChecks),
                content: <BonusChecks />,
                disabled: !hasBonusSupport,
              },
            ]}
          />
        </Column>
      </Columns>
    </Container>
  )
}

PspPaymentMethod.propTypes = {
  selectedPaymentMethod: PropTypes.object.isRequired,
  newPageLoading: PropTypes.bool.isRequired,
  debitPaymentChecked: PropTypes.bool.isRequired,
  onDebitPaymentSwitch: PropTypes.func.isRequired,
  onChangeAmount: PropTypes.func.isRequired,
  debitReference: PropTypes.string,
  onChangeDebitReference: PropTypes.func.isRequired,
  bonusChecks: PropTypes.array.isRequired,
  hasBonusSupport: PropTypes.bool.isRequired,
  isValid: PropTypes.func.isRequired,
}

PspPaymentMethod.defaultProps = {
  debitReference: null,
}

export default PspPaymentMethod
